import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-watchlist-modal',
  templateUrl: './watchlist-modal.component.html',
  styleUrls: ['./watchlist-modal.component.scss']
})
export class WatchlistModalComponent implements OnInit {

  public isLogged = false;
  public loggedUser: any = { email: 'arlindo@email.com'};
  public email: string = '';

  constructor(
    public dialogRef: MatDialogRef<WatchlistModalComponent>
  ) { }

  ngOnInit(): void {
    this.getLoggedUser();
  }

  getLoggedUser(): void {
    // Buscar no  serviço o usuário logado
    this.isLogged = true;
    this.email = this.loggedUser.email;
  }

  close() {
    this.dialogRef.close();
  }

}
